import { render, staticRenderFns } from "./supplierFrom.vue?vue&type=template&id=3c8fca57&scoped=true"
import script from "./supplierFrom.vue?vue&type=script&lang=js"
export * from "./supplierFrom.vue?vue&type=script&lang=js"
import style0 from "./supplierFrom.vue?vue&type=style&index=0&id=3c8fca57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8fca57",
  null
  
)

export default component.exports